<template>
    <div class="chat-initiator-template">
        <md-progress-bar md-mode="indeterminate" v-if="loading" />
        <div class="header">
            <div class="title">{{$t("whatsapp_business_api.numbers")}}</div>
        </div>
        <div class="title">{{$t("whatsapp_business_api.allOptNumbers")}}</div>
        <div class="d-flex justify-content-end w-100">
            <a-pagination
                :key="Math.random()"
                size="small"
                :total="total"
                :show-total="(total) => `Total ${total} number`"
                v-model="currentPage"
                show-size-changer
                show-quick-jumper
                :pageSizeOptions="['10', '20', '50', '100', '300', '500', '1000']"
                :defaultPageSize="maxResult"
                @showSizeChange="(current, size) => (maxResult = size)"
                :disabled="loading"
            />
        </div>

        <a-table :columns="columns" :data-source="numbers" :pagination="false" row-key="id" size="small">
            <span slot="blocked" slot-scope="text, record">
                <a-switch class="md-warning ml-3" name="writing" v-model="record.blocked" @change="$_.noop" />
            </span>
            <span slot="active" slot-scope="text, record">
                <a-switch class="md-warning ml-3" name="writing" v-model="record.active" @change="$_.noop" />
            </span>
            <span slot="lastMessageSentTs" slot-scope="text, record">
                {{ $moment(record.lastMessageSentTs).format("YYYY-MM-DD HH:mm:ss") }}
            </span>
            <span slot="options" slot-scope="text, record">
                <a-button class="process-button" @click="() => startChat(record.phone)"> {{$t("whatsapp_business_api.startChat")}} </a-button>
            </span>
        </a-table>
    </div>
</template>
<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import _ from "lodash";

import { sendSocketMessage, socketMessageStream } from "../../../../utils/socketStream";
import log2 from "../../../../utils/log2";
import IconButton from "../../Settings/components/IconButton.vue";
import ChatWatcher from "../../../../ChatWatcherV2";

const log = log2("Numbers.vue");
export default Vue.extend({
    name: "Numbers",
    components: { IconButton },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            total: 0,
            currentPage: 1,
            maxResult: 100,
            numbers: [],
            columns: [
                {
                    title: this.$t("message.country"),
                    dataIndex: "countryCode",
                    key: "countryCode",
                    scopedSlots: { customRender: "countryCode" },
                },
                {
                    title: this.$t("message.phone"),
                    dataIndex: "dialCode",
                    key: "dialCode",
                },
                {
                    title: this.$t("message.active"),
                    dataIndex: "active",
                    key: "active",
                    scopedSlots: { customRender: "active" },
                },
                {
                    title: this.$t("message.blocked"),
                    dataIndex: "blocked",
                    key: "blocked",
                    scopedSlots: { customRender: "blocked" },
                },
                {
                    title: this.$t("whatsapp_business_api.lastMessageDate"),
                    dataIndex: "lastMessageSentTs",
                    key: "lastMessageSentTs",
                    scopedSlots: { customRender: "lastMessageSentTs" },
                },
                {
                    title: "",
                    dataIndex: "_id",
                    key: "_id",
                    scopedSlots: { customRender: "options" },
                },
            ],
        };
    },
    computed: {
        ...mapState({
            socketConnected: (state) => state.socketStatus.socket_connected,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({
            myActiveConversations: "chat/getMyActiveConversations",
        }),
    },
    methods: {
        listenSocketMessages() {
            this.subscriber = socketMessageStream.subscribe((message) => {
                if (message.cmd === "whatsapp_optin_user_list_response") {
                    log("whatsapp_optin_user_list_response=>", message);
                    this.numbers = _.orderBy(message.data.users, "lastMessageSentTs", "desc");
                    this.total = message.data.total;
                    this.loading = false;
                }
            });
        },
        getNumbers() {
            this.loading = true;
            sendSocketMessage("whatsapp get-optin-user-list", {
                channelId: this.value._id,
                siteId: this.site._id,
                pageNo: this.currentPage,
                maxResult: this.maxResult,
            });
        },
        nextPage() {
            if (this.currentPage * this.maxResult < this.count) {
                this.currentPage++;
                // this.getNumbers();
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                // this.getNumbers();
            }
        },
        startChat(whatsappNumber) {
            log("startChat", { whatsappNumber });
            ChatWatcher.startChatImmediately({
                whatsappNumber: whatsappNumber,
                channelId: this.value._id,
                channelType: "whatsapp-business-api",
            });
        },
    },
    mounted() {
        this.listenSocketMessages();
        this.getNumbers();
    },
    watch: {
        currentPage() {
            this.getNumbers();
        },
        maxResult() {
            this.currentPage = 1;
            this.getNumbers();
        },
        socketConnected(isConnected) {
            if (isConnected) {
                this.getNumbers();
            }
        },
        clone: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.value);
                    if (isChanged) {
                        log("clone changed=>", val);
                        this.$emit("input", val);
                    }
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.chat-initiator-template {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
    position: relative;

    .md-progress-bar {
        position: absolute;
        top: 0;
        width: 100%;
        margin-left: -20px;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 10px;

        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }
}
</style>
